window.addEventListener('DOMContentLoaded', function(){
document.querySelectorAll('.fast-add').forEach(function(b){
   
    b.addEventListener('click',function(){ 
      var par = b.closest('.fastadd-wrp');
      if(par.classList.contains('open--sizes')){
        document.querySelectorAll('.fastadd-wrp').forEach(function(c){c.classList.remove('open--sizes')})
      }else{
        document.querySelectorAll('.fastadd-wrp').forEach(function(c){c.classList.remove('open--sizes')})
        par.classList.toggle('open--sizes');
      }
      
      })
    })
  document.querySelectorAll('.fastadd-product').forEach(function(co){
    co.addEventListener('mouseenter',function(){
      co.querySelector('.fastadd-wrp').classList.add('hover');
      })
    co.addEventListener('mouseleave',function(){
      co.querySelector('.fastadd-wrp').classList.remove('hover');
      })
    })
  document.querySelectorAll('.swatch__input').forEach(function(s){
    s.addEventListener('change',function(){
      var par=s.closest('.fastadd-product');
      if (par) {
        par.classList.remove('hover');
        par.classList.remove('open--sizes');
      }
      var id=this.value;
       if(id != null){
        var form_data={quantity: 1, id: id};
        $.ajax({
  			method: 'POST',
  			url: '/cart/add.js',
  			dataType: 'json',
  			data: form_data,
  			success: function(product){
            
  				/*addToCart.attr( 'disabled', true )
  				addToCartText.html( window.theme.icons.check );
  
  				setTimeout(function(){
  					addToCart.attr( 'disabled', false );
  					addToCartText.html( window.theme.translations.form_submit );
  				}, 2000);*/

          if (!sessionStorage.getItem("drawer_cart_opened")) {
            document.querySelector('cart-drawer').open('openCookie');
          } else {
            if ($(window).width() >= 200){
              Cart.popover.show(product);
            }
          }
           
              var item_vr='';
              var item_color='';
              if(product.options_with_values.length>0){
                product.options_with_values.forEach(function(e){
                  if(e.name == 'Color' || e.name=='color'){
                    item_color=e.value;
                  }
                  if(e.name == 'Talla' || e.name=='talla'){
                    item_vr=e.value
                  };
                })
              }
                dataLayer.push({ ecommerce: null }); 
                dataLayer.push({
                  event: "add_to_cart",
                  ecommerce: {
                    items: [{
                       item_name: product.title,  
                       item_id: product.id,
                       item_color:item_color,
                       item_variant:item_vr,
                       item_category:product.type,
                       price: product.price,
                       item_brand: product.vendor,
                       index: 1, 
                      quantity: 1
                    }]
                  }
                 })
  
  				Cart.getCart(Cart.buildCart);
              s.checked = false;
  
  				
  			},
  			// If there are no products in the inventory
  			error: function(data){
  				
  			console.log("Error: product is out of stock. If you're seeing this, Cart.submit.error() must have failed.");
  					
  				
  			}
  		});
        }else{
          alert('Elija una talla primero')
        }
      })
  })

  document.querySelectorAll('.product-list--container').forEach(function(e, i) {
    e.setAttribute('data-h', e.querySelector('.product-list--wrp').offsetHeight);
    e.style.height = '0px';
  });
  
  window.addEventListener('resize', function() {
    document.querySelectorAll('.product-list--container').forEach(function(e, i) {
      e.setAttribute('data-h', e.querySelector('.product-list--wrp').offsetHeight);
    });
  });
  
  setTimeout(()=> {    
    window.dispatchEvent(new Event('resize'));
  }, 2000)
  
  document.querySelectorAll('.pro--title--wrp').forEach(function(e,i){
    e.addEventListener('click',function(){
      let ns=e.nextElementSibling;
      let par=e.parentNode;
      par.classList.toggle('pro-open');
      if(par.classList.contains('pro-open')){
        
        ns.style.height=ns.getAttribute('data-h')+'px';
      }else{
        ns.style.height=0;
      }
    })
  })

  
})
window.addEventListener('scroll', function(){

    if(window.innerWidth < 640){ 
      if(window.pageYOffset > delta + 30 ||window.pageYOffset < delta - 30){
       document.querySelectorAll('.fastadd-wrp').forEach(function(e,i){
        e.classList.remove('open--sizes')
      });
        delta=window.pageYOffset;
      }

    }

})                        